import { useUniqueId } from '@cloudscape-design/component-toolkit/internal';
import { useInternalI18n } from '../../i18n/context';
import { useDropdownStatus } from '../../internal/components/dropdown-status';
/**
 * Derives the async loading status UI of an expandable group from `getExpandableItemsAsyncLoadingState`.
 * Shared by the desktop (fly-out) and mobile (inline) expandable category elements so both render the
 * same loading, error, empty, and finished states.
 */
export function useExpandableGroupStatus({ item, asyncLoadingProps, getExpandableItemsAsyncLoadingState, onGroupRecoveryClick, filteringEnabled, triggerRef, }) {
    var _a, _b, _c, _d;
    const groupId = item.id;
    const footerId = useUniqueId('awsui-button-dropdown__group-footer');
    const hasGroupItems = !!item.items && item.items.length > 0;
    // A group is loaded as a whole, so `pending` (more pages available) has no meaning here.
    const reportedStatus = groupId ? getExpandableItemsAsyncLoadingState === null || getExpandableItemsAsyncLoadingState === void 0 ? void 0 : getExpandableItemsAsyncLoadingState({ item }) : undefined;
    const statusType = reportedStatus === 'pending' ? 'finished' : (reportedStatus !== null && reportedStatus !== void 0 ? reportedStatus : undefined);
    const i18n = useInternalI18n('button-dropdown');
    const recoveryText = i18n('recoveryText', asyncLoadingProps === null || asyncLoadingProps === void 0 ? void 0 : asyncLoadingProps.recoveryText);
    const errorIconAriaLabel = i18n('errorIconAriaLabel', asyncLoadingProps === null || asyncLoadingProps === void 0 ? void 0 : asyncLoadingProps.errorIconAriaLabel);
    const status = useDropdownStatus({
        statusType,
        empty: (_a = asyncLoadingProps === null || asyncLoadingProps === void 0 ? void 0 : asyncLoadingProps.empty) === null || _a === void 0 ? void 0 : _a.call(asyncLoadingProps, groupId),
        loadingText: (_b = asyncLoadingProps === null || asyncLoadingProps === void 0 ? void 0 : asyncLoadingProps.loadingText) === null || _b === void 0 ? void 0 : _b.call(asyncLoadingProps, groupId),
        finishedText: (_c = asyncLoadingProps === null || asyncLoadingProps === void 0 ? void 0 : asyncLoadingProps.finishedText) === null || _c === void 0 ? void 0 : _c.call(asyncLoadingProps, groupId),
        errorText: (_d = asyncLoadingProps === null || asyncLoadingProps === void 0 ? void 0 : asyncLoadingProps.errorText) === null || _d === void 0 ? void 0 : _d.call(asyncLoadingProps, groupId),
        recoveryText,
        errorIconAriaLabel,
        isEmpty: !hasGroupItems,
        isNoMatch: false,
        hasRecoveryCallback: !!onGroupRecoveryClick,
        onRecoveryClick: () => {
            var _a;
            if (groupId) {
                onGroupRecoveryClick === null || onGroupRecoveryClick === void 0 ? void 0 : onGroupRecoveryClick(groupId);
            }
            // The recovery button disappears once loading starts. In menu mode keep focus on the group
            // header so the dropdown stays open; in filtering mode the root moves focus back to the filter.
            if (!filteringEnabled) {
                (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        },
    });
    return { status, footerId, hasGroupItems };
}
//# sourceMappingURL=use-expandable-group-status.js.map